import { html } from "lit";
import { loading } from "../constants/api-constants";

export function getCheckoutLoader() {
    return html`
      <span class="visually-hidden">Loading checkout steps</span>
      ${loading({bg: 'bg-secondary', height: '2.25rem', animation: false, m: ''})}
      ${loading({columns: 2})}
      ${loading({columns: 1, m: 'mt-4', width: '25%'})}
      ${loading({columns: 1, m: 'mt-3'})}
      ${loading({columns: 1, m: 'mt-4', width: '25%'})}
      ${loading({columns: 1, m: 'mt-3'})}
      ${loading({columns: 1, m: 'mt-4', width: '25%'})}
      ${loading({columns: 1, m: 'mt-3'})}
      ${loading({columns: 2, m: 'mt-3'})}
      ${loading({columns: 1, m: 'mt-4', width: '25%'})}
      ${loading({columns: 1, m: 'mt-3'})}
      ${loading({height: '2.25rem', animation: false, m: 'mt-4'})}
      ${loading({width: '55%'})}
      ${loading({width: '30%'})}
      ${loading({width: '45%'})}
      ${loading({height: '2.25rem', animation: false, m: 'mt-4'})}
      ${loading({width: '35%'})}
      ${loading({width: '50%'})}
      ${loading({width: '43%'})}
    `;
}